import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import SimpleReactValidator from 'simple-react-validator';
import Chat from '../../Models/Chat';
import axios from 'axios';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Common from "../../Models/Common";
class BuyerDirectMessage extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert(this.props.t('6'))
            this.props.history.push('/login/buyer');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        var url = decodeURIComponent(this.props.match.params.id).split('&')
        var seller_id = url[url.length - 1]
        var buyer_id = url[url.length - 2]
        this.state = {
            conversation: [],
            other: [],
            content: '',
            seller: '',
            buyer: '',
            sender: '',
            receiver: '',
            buyer_id: buyer_id,
            seller_id: seller_id,
            user: logged_user.id,
            userImage: logged_user.img_sidebar,
            attchmnt: null,
            modal: false
        }
        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('7')}`,
            max: `:attribute :max ${this.props.t('4')} .`,
            required: ` :attribute ${this.props.t('9')}`,
            min: `:attribute :min ${this.props.t('5')}`,
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        console.log(this.props.location.state)
        Chat.getConversationBuyerSolo(this.state.buyer_id, this.state.seller_id).then(res => {
            this.setState({ conversation: res.data.payload })
            this.setState({ other: res.data.other_side })
            this.setState({ seller: this.state.seller_id })
            this.setState({ buyer: this.state.buyer_id })
            this.setState({ sender: this.state.user })
            if (this.state.sender == this.state.buyer_id) {
                this.setState({ receiver: this.state.seller_id })
            } else {
                this.setState({ receiver: this.state.buyer_id })
            }

        })
        console.log(this.state.conversation)
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
        console.log(this.state.modal)
    }

    onChangePro(e) {
        this.setState({ attchmnt: e.target.files[0] })
    }
    handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData();
        formData.append('attchmnt', this.state.attchmnt)
        if (this.state.content !== null && this.state.content !== '') {
            formData.append('seller', this.state.seller)
            formData.append('buyer', this.state.buyer)
            formData.append('sender', this.state.sender)
            formData.append('receiver', this.state.receiver)
            formData.append('content', this.state.content)
            console.log(formData)
            axios({
                method: 'post',
                url: Common.api + 'store-msg',
                // url: 'http://192.168.1.110/sharework_back_v2/public/backend/store-msg',
                // url: 'https://sharework-admin.bitpeboot.com/backend/update-basic-profile',
                data: formData,
                config: {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            }).then(res => {
                console.log(res.data)
                if (res.data.status === 200) {
                    alert(this.props.t('1')+"!")
                    window.location.reload()
                }
            })
        } else {
            this.setState({
                modal: !this.state.modal
              },() => {setTimeout(this.toggle.bind(this), 3000)});
            // this.setState(prevState => ({
            //     modal: !prevState.modal
            // },()=>{setTimeout(this.toggle.bind(this),3000)});
            // );
            // this.toggle.bind(this)
            // this.state.modal = !this.state.modal
        }

    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view
        if (isMobile) {
            return (
                <div>
                    <Modal size='sm' isOpen={this.state.modal} modalTransition={{ timeout: 1 }} backdropTransition={{ timeout: 5 }}
                        toggle={this.toggle.bind(this)}>
                        {/* <ModalHeader toggle={this.toggle.bind(this)}>Modal title</ModalHeader> */}
                        <ModalBody>
                            {this.props.t('0')}
                           </ModalBody>
                        <ModalFooter>
                            {/* <Button color="primary" onClick={this.toggle.bind(this)}>Do Something</Button>{' '} */}
                            <Button color="secondary" onClick={this.toggle.bind(this)}>{this.props.t('10')}</Button>
                        </ModalFooter>
                    </Modal>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div> */}
                            <div className="col-md-8">
                                <div className=" row">
                                    <div className="col-10" style={{ paddingLeft: "22px" }}>
                                        <div className="mt-5 input_name big_font " style={{ width: '100%', fontSize: '20px', textAlign: 'left' }}>
                                            {this.props.t('2')}
                                        </div>
                                    </div>
                                    <div className="col-2 mt-5">
                                        <Link to={'/buyer-direct-message-list'} className=" text-right return_text mt-5 mb-3">
                                            <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                                        </Link>
                                    </div>
                                </div>
                                <div className="m-2" style={{ height: "auto !important", border: "1px solid #e6e6e6", padding: "3%", minHeight: "100px", overflow: "auto" }}>
                                    <div className="m-2">
                                        <div className="col-md-12 " style={{ border: "1px solid #e6e6e6", padding: "2%", borderRadius: "5px" }}>
                                            <div className="col-md-8 m-2">
                                                <div className="user_message" style={{ fontSize: '14px' }}>
                                                    <b><i>{this.state.other.first_name}</i></b>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.conversation.map(conv =>
                                        <div>
                                            <div className="m-2">
                                                <div className="row">
                                                    {/* <div className="col-md-2 mini_pad m-2">
                                                        <img src={conv.img_sender} className=" rounded-circle" alt="" width="100" height="100" style={{ objectFit: 'cover' }} /><br />
                                                    </div> */}
                                                    <div className="col-md-7 ">
                                                        <div className="message_name_text">
                                                            <span><b>{conv.sender}</b></span><br />
                                                        </div>
                                                        <div className="product_description">
                                                            {conv.content.split('\n').map(function (item, key) {
                                                                return (
                                                                    <span key={key}>
                                                                        {item}
                                                                        <br />
                                                                    </span>
                                                                )
                                                            })}
                                                        </div>
                                                        {(() => {
                                                            if (conv.file !== '') {
                                                                return (
                                                                    <div style={{ fontSize: "13px" }}>
                                                                        <a href={conv.attchmnt} target="_blank">{conv.file}</a>
                                                                    </div>
                                                                )
                                                            } else {
                                                                return (
                                                                    <div></div>
                                                                )
                                                            }
                                                        })()}
                                                        <div className="message_open_time">
                                                            &nbsp;
                                                                </div>
                                                    </div>
                                                    <div className="col-md-3 message_time">
                                                        {(JSON.stringify(conv.created_at)).substring(1, 11)}
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        </div>
                                    )}
                                    <div className="m-2">
                                        <div className="row">
                                            <div className="col-md-10" style={{ borderRadius: "0px" }}>
                                                <div className="row row_edit" >
                                                    <div className="col-md-3 message text-left" style={{}}>
                                                        <span className=""><b>{this.props.t('11')}</b></span><br />
                                                    </div>
                                                    {/* <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>

                                                    </div> */}
                                                </div>
                                                <div className="message_form" style={{ borderRadius: "0px", padding: "2%" }}>
                                                    <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                        value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                    </textarea>
                                                    <input style={{ fontSize: "13px", paddingLeft: '10px' }} type="file" className="" onChange={this.onChangePro.bind(this)}></input>

                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('11'), this.state.editor_msg, 'required|min:1|max:500')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center p-3 " >
                                            <button onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg  " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                <span className="fa fa-check"></span>
                                                {this.props.t('17')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for Desktop view
        else if (isDesktop) {
            return (
                <div>
                    <div>
                        {/* <Button color="danger" onClick={this.toggle.bind(this)}>asdas</Button> */}
                        <Modal size='sm' isOpen={this.state.modal} modalTransition={{ timeout: 1 }} backdropTransition={{ timeout: 5 }}
                            toggle={this.toggle.bind(this)}>
                            {/* <ModalHeader toggle={this.toggle.bind(this)}>Modal title</ModalHeader> */}
                            <ModalBody>
                                {this.props.t('8')}
                           </ModalBody>
                            <ModalFooter>
                                {/* <Button color="primary" onClick={this.toggle.bind(this)}>Do Something</Button>{' '} */}
                                <Button color="secondary" onClick={this.toggle.bind(this)}>{this.props.t('10')}</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className=" row">
                                            <div className="col-md-10" style={{ paddingLeft: "22px" }}>
                                                <div className="mb-1 input_name big_font " style={{ width: '100%', textAlign: 'left' }}>
                                                    {this.props.t('2')}
                                                </div>
                                            </div>
                                            <div className="col-md-2" style={{ paddingLeft: '33px' }} >
                                                <Link to={'/buyer-direct-message-list'} className="col-md-5 text-right return_text mt-5 mb-3">
                                                    <img src={require("../../assets/images/Easy_Returns-512.png")} alt="" className="" alt="" style={{ width: "30px", height: "30px" }} />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="m-2" style={{ height: "auto !important", border: "1px solid #e6e6e6", padding: "3%", minheight: "1100px", overflow: "auto" }}>
                                            <div className="m-2">
                                                <div className="m-2 row">
                                                    <div className="col-md-12 row" style={{ border: "1px solid #e6e6e6", padding: "2%", borderRadius: "5px" }}>
                                                        <div className="col-md-8 m-2">
                                                            <div className="user_message">
                                                                <b><i>{this.state.other.first_name}</i></b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>&nbsp;</div>
                                            </div>
                                            {this.state.conversation.map(conv =>
                                                <div>
                                                    <div className="m-2">
                                                        <div className="row">
                                                            <div className="col-md-2 mini_pad">
                                                                <img src={Common.baseUrl+conv.img_sender} className=" rounded-circle" alt="" width="70" height="70" style={{ objectFit: 'cover' }} /><br />
                                                                {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                            </div>
                                                            <div className="col-md-7 ">
                                                                <div className="message_name_text">
                                                                    <span><b>{conv.sender}</b></span><br />
                                                                </div>
                                                                <div className="product_description">
                                                                    {conv.content.split('\n').map(function (item, key) {
                                                                        return (
                                                                            <span key={key}>
                                                                                {item}
                                                                                <br />
                                                                            </span>
                                                                        )
                                                                    })}
                                                                </div>
                                                                {(() => {
                                                                    if (conv.file !== '') {
                                                                        return (
                                                                            <div style={{ fontSize: "13px" }}>
                                                                                <a href={conv.attchmnt} target="_blank">{conv.file}</a>
                                                                            </div>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <div></div>
                                                                        )
                                                                    }
                                                                })()}
                                                                <div className="message_open_time">
                                                                    &nbsp;
                                                                        </div>
                                                            </div>
                                                            <div className="col-md-3 message_time">
                                                                {(JSON.stringify(conv.created_at)).substring(1, 11)}
                                                            </div>
                                                        </div>
                                                        <hr />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="m-2">
                                                <div className="row">
                                                    <div className="col-md-2 mini_pad">
                                                        <img src={Common.baseUrl+this.state.userImage} className=" rounded-circle" alt="" width="70" height="70" style={{ objectFit: 'cover' }} /><br />
                                                        {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                    </div>
                                                    <div className="col-md-10" style={{ borderRadius: "3px" }}>
                                                        <div className="row row_edit" >
                                                            <div className="col-md-3 message text-center" style={{ borderRadius: "3px", paddingLeft: '3px' }}>
                                                                <span className=""><b>{this.props.t('11')}</b></span><br />
                                                            </div>
                                                            <div className="col-md-9" style={{ borderBottom: "1px solid #ccc" }}>

                                                            </div>
                                                        </div>
                                                        <div className="message_form" style={{ borderRadius: "3px", padding: "2%" }}>
                                                            <textarea style={{ border: "1px solid gray" }} className="message_textarea m-2"
                                                                value={this.state.content} onChange={this.updateValue.bind(this, 'content')}>
                                                            </textarea>
                                                            <div className="col-md-12" style={{ paddingLeft: '9px' }}>
                                                                <input style={{ fontSize: "13px" }} type="file" onChange={this.onChangePro.bind(this)}></input>
                                                            </div>
                                                        </div>
                                                        {/* <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('11'), this.state.editor_msg, 'required|min:1|max:500')}</span> */}

                                                        {/* <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message(this.props.t('11'), this.state.editor_msg, 'required|min:1|max:500')}</span> */}
                                                    </div>

                                                </div>

                                                <div className="text-center p-3 " >
                                                    <button onClick={this.handleSubmit.bind(this)} type="submit" className="btn btn-lg  " style={{ backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }} >
                                                        <span className="fa fa-check"></span>
                                                        {this.props.t('17')}
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { BuyerDirectMessage }


 BuyerDirectMessage = withTranslation('src_Components_DirectMessage_BuyerDirectMessage')(BuyerDirectMessage);
